import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import TreeView from '@material-ui/lab/TreeView';
import __TreeItem from '@material-ui/lab/TreeItem';
import Typography from '@material-ui/core/Typography';
import MailIcon from '@material-ui/icons/Mail';
import DeleteIcon from '@material-ui/icons/Delete';
import Label from '@material-ui/icons/Label';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import InfoIcon from '@material-ui/icons/Info';
import ForumIcon from '@material-ui/icons/Forum';
import LocalOfferIcon from '@material-ui/icons/LocalOffer';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import FolderIcon from '@material-ui/icons/Folder';
import FolderOpenIcon from '@material-ui/icons/FolderOpen';
import { CircularProgress, DialogActions, IconButton, Divider } from '@material-ui/core';

const useTreeItemStyles = makeStyles((theme) => ({
    root: {
        color: theme.palette.text.secondary,
        '&:hover > $content': {
            backgroundColor: theme.palette.action.hover,
        },
        '&:focus > $content, &$selected > $content': {
            backgroundColor: `var(--tree-view-bg-color, ${theme.palette.grey[400]})`,
            color: 'var(--tree-view-color)',
        },
        '&:focus > $content $label, &:hover > $content $label, &$selected > $content $label': {
            backgroundColor: 'transparent',
        },
    },
    content: {
        color: theme.palette.text.secondary,
        borderTopRightRadius: theme.spacing(2),
        borderBottomRightRadius: theme.spacing(2),
        paddingRight: theme.spacing(1),
        fontWeight: theme.typography.fontWeightMedium,
        '$expanded > &': {
            fontWeight: theme.typography.fontWeightRegular,
        },
    },
    group: {
        marginLeft: 0,
        '& $content': {
            paddingLeft: theme.spacing(2),
        },
    },
    expanded: {},
    selected: {},
    label: {
        fontWeight: 'inherit',
        color: 'inherit',
    },
    labelRoot: {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(0.5, 0),
        color: props => props.disabled ? "#9e9e9e" : null
    },
    labelIcon: {
        marginRight: theme.spacing(1),
    },
    labelText: {
        fontWeight: 'inherit',
        flexGrow: 1,
    },
}));

export const TreeItem = forwardRef((props, ref) => {
    let classes = useTreeItemStyles(props);
    return (
        <_TreeItem {...props} classes={classes} ref={ref} />
    )
});

class _TreeItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    /*     getLabelIcon(classes) {
            let { labelIcon, expandIcon, collapseIcon, isOpen,children } = this.props;
            if (!labelIcon && !expandIcon && !collapseIcon) return null;
    
            let expand = expandIcon || labelIcon || collapseIcon;
            let collapse = collapseIcon || labelIcon || expandIcon;
    
            let LabelIcon = children ? (isOpen ? expand : collapse) : collapse;
            return <LabelIcon color="inherit" className={classes.labelIcon} />;
        }
     */
    onClick() {
        let { onClick } = this.props;
        if (onClick) onClick();
    }

    render() {
        let { isOpen, disabled, labelText, labelIcon: LabelIcon, collapseIcon, expandIcon, labelInfo, color, bgColor, classes, onClick, ...other } = this.props;
        classes = classes || {};
        return (
            <__TreeItem
                onClick={(e) => { if (!disabled) e.preventDefault(); this.onClick(); }}
                label={
                    <div className={classes.labelRoot}>

                        {LabelIcon ? <LabelIcon color="inherit" className={classes.labelIcon} /> : null}

                        {labelText ? <Typography variant="body2" className={classes.labelText}>
                            {labelText}
                        </Typography> : null}

                        {labelInfo ? <Typography variant="caption" color="inherit">
                            {labelInfo}
                        </Typography> : null}
                    </div>
                }

                style={{
                    '--tree-view-color': color,
                    '--tree-view-bg-color': bgColor,
                }}
                classes={{
                    root: classes.root,
                    expanded: classes.expanded,
                    selected: classes.selected,

                    label: classes.label,
                }}
                {...other}
            />
        );
    }
}

export class TreeLoading extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            data: {}
        }
    }

    render() {
        let { className, size } = this.props;
        return <_TreeItem nodeId={`Temp_Loading_nodeId`} label={
            <div className={`d-flex flex-row align-items-center c-text-grey c-my-1d5 ${className}`}>
                <CircularProgress size={size || 20} color={'inherit'} />
            </div>
        } />

    }

}
